export default __webpack_public_path__ + "static/newsletter-fox-image-49714cc2bae8bf01dae18358528e9fdc.png";